
import React from 'react'

const MarkInConstructionSummary = ({ comment }: any) => {
    return (
        <div>
            <h4 className='mb-4'>Summary Information</h4>

            <div>
                <p className='mb-1 fw-bold'>Comments:</p>
                <p>{comment}</p>
            </div>
        </div>
    )
}

export default MarkInConstructionSummary